// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
    //API_Base_URL: 'https://localhost:44372/api/',                 //local
   // Manage_URL: 'http://localhost:92/api/',
    // Admin_URL:"http://192.168.1.8:7075/api/",                        
    //API_Base_URL: 'http://106.51.65.164:99/api/',                 //for hosting
    // API_Base_URL: 'http://192.168.1.8:7075/api/',
  //  Manage_URL:'http://106.51.65.164:8077/api/'                 //for hosting
    // Manage_URL:'http://192.168.1.8:7075/api/'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
